import { render, staticRenderFns } from "./imageTemplate.vue?vue&type=template&id=13558b4c"
import script from "./imageTemplate.vue?vue&type=script&lang=js"
export * from "./imageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports